import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = {
  key: 0,
  class: "md:flex items-center justify-between"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "mr-4 hidden lg:block" }, "Input Barang", -1)
const _hoisted_5 = { class: "flex mt-4 md:mt-0" }
const _hoisted_6 = { class: "p-inputgroup w-1/2 md:w-24 lg:w-44" }
const _hoisted_7 = { class: "p-inputgroup-addon w-1/3 lg:w-3/5" }
const _hoisted_8 = { class: "truncate" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "text-3xl mx-3" }, " / ", -1)
const _hoisted_10 = { class: "p-inputgroup w-1/2 md:w-24" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createTextVNode(" m"),
  /*#__PURE__*/_createVNode("sup", null, "3")
], -1)
const _hoisted_12 = { class: "flex gap-0 sm:gap-0 mt-4 md:mt-0" }
const _hoisted_13 = { class: "p-inputgroup w-1/2 lg:w-52 md:w-24 md:mx-2 mr-2 md:mr-0" }
const _hoisted_14 = { class: "w-1/2 lg:w-auto md:w-28 md:52 lg:64" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "flex items-center w-full justify-center" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-black mr-2" }, "Input"),
  /*#__PURE__*/_createVNode("i", { class: "pi pi-arrow-down text-black text-xs font-bold" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("small", { class: "mb-4 mt-2 hidden sm:flex" }, "* Input kategori barang terlebih dahulu, sebelum ke langkah selanjutnya", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "flex items-center p-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "mr-2 text-subtitle1" }, "Daftar Barang Akan Dikirim")
], -1)
const _hoisted_18 = { class: "text-sm font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_19 = { class: "text-xs text-black font-semibold px-4 h-14 flex items-center" }
const _hoisted_20 = { class: "text-sm text-black font-semibold px-4 h-14 flex items-center" }
const _hoisted_21 = { class: "px-4" }
const _hoisted_22 = { class: "px-4" }
const _hoisted_23 = { class: "px-4 h-14 flex items-center" }
const _hoisted_24 = { class: "flex items-center action-button" }
const _hoisted_25 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-1 h-6 w-6 color-primary",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16"
}
const _hoisted_26 = { fill: "none" }
const _hoisted_27 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("g", { fill: "none" }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M16.34 9.322a1 1 0 1 0-1.364-1.463l-2.926 2.728L9.322 7.66A1 1 0 0 0 7.86 9.024l2.728 2.926l-2.927 2.728a1 1 0 1 0 1.364 1.462l2.926-2.727l2.728 2.926a1 1 0 1 0 1.462-1.363l-2.727-2.926l2.926-2.728z",
      fill: "#F44336"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12zm11 9a9 9 0 1 1 0-18a9 9 0 0 1 0 18z",
      fill: "#F44336"
    })
  ])
], -1)
const _hoisted_28 = { class: "flex items-end justify-between" }
const _hoisted_29 = { class: "action-button" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Ke Pembayaran")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_32 = { class: "action-button w-full text-right" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Simpan ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (!_ctx.isMiisi)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("form", {
            id: "add-items",
            class: "md:flex items-center mb-1 flex-1 sm:w-full",
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submitCategoryItem()), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Multiselect, {
                id: "categoryItemsId",
                modelValue: _ctx.categoryItemsId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.categoryItemsId = $event)),
                searchable: true,
                class: "md:mr-3 input-primary w-full md:w-auto",
                trackBy: "Nama",
                label: "Nama",
                valueProp: "Id",
                onChange: _ctx.onChangeCategoryItem,
                options: _ctx.listCategoryItems,
                "allow-empty": true,
                placeholder: "Pilih kategori barang"
              }, null, 8, ["modelValue", "onChange", "options"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_InputText, {
                  type: "number",
                  modelValue: _ctx.weight,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.weight = $event)),
                  class: "input-primary",
                  placeholder: "",
                  min: 0
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, _toDisplayString(_ctx.textWeight), 1)
                ])
              ]),
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_InputText, {
                  type: "number",
                  modelValue: _ctx.volume,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.volume = $event)),
                  class: "input-primary",
                  placeholder: ""
                }, null, 8, ["modelValue"]),
                _hoisted_11
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_InputNumber, {
                  class: "input-primary rounded-lg text-center",
                  modelValue: _ctx.totalSend,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.totalSend = $event)),
                  showButtons: "",
                  buttonLayout: "horizontal",
                  incrementButtonIcon: "pi pi-plus",
                  decrementButtonIcon: "pi pi-minus",
                  min: 1,
                  placeholder: "Jumlah"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_Multiselect, {
                  id: "insuranceId",
                  class: "md:mt-1 rounded-lg md:mx-2 input-primary",
                  modelValue: _ctx.insuranceId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.insuranceId = $event)),
                  options: _ctx.listInsurance,
                  placeholder: "Pilih jenis asuransi",
                  searchable: true,
                  disabled: _ctx.disableInsurance
                }, null, 8, ["modelValue", "options", "disabled"])
              ])
            ])
          ], 32),
          _createVNode(_component_Button, {
            class: "btn-primary w-full md:w-auto my-8 md:my-0",
            type: "submit",
            form: "add-items"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_16,
    _createVNode(_component_Card, { class: "card-no-shadow card-p-0 mb-8" }, {
      content: _withCtx(() => [
        _hoisted_17,
        _createVNode(_component_DataTable, {
          value: _ctx.dataItems,
          class: "table-og body-td-x-0",
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "Satuan" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_18, _toDisplayString(slotProps.data.Berat) + " " + _toDisplayString(slotProps.data.Satuan), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Kategori Barang",
              field: "Jadwal"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_19, _toDisplayString(slotProps.data.KategoriBarang), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Biaya Barang" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_20, "Rp " + _toDisplayString(new
      Number(slotProps.data.Harga).toLocaleString("id-ID")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Asuransi" }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_21, _toDisplayString(slotProps.data.NamaAsuransi), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Biaya Tambahan" }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_22, [
                  _createVNode(_component_InputNumber, {
                    class: "input-primary rounded-lg w-48",
                    placeholder: `Max Rp ${new Number(slotProps.data.TambahanMax).toLocaleString('id-ID')}`,
                    min: slotProps.data.TambahanMin,
                    max: slotProps.data.TambahanMax,
                    modelValue: slotProps.data.BiayaTambahan,
                    "onUpdate:modelValue": ($event: any) => (slotProps.data.BiayaTambahan = $event),
                    modelModifiers: { lazy: true },
                    disabled: _ctx.isMiisi
                  }, null, 8, ["placeholder", "min", "max", "modelValue", "onUpdate:modelValue", "disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, _createSlots({ _: 2 }, [
              (!_ctx.isMiisi)
                ? {
                    name: "body",
                    fn: _withCtx((slotProps) => [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", {
                            class: "flex items-center mr-3 cursor-pointer",
                            onClick: ($event: any) => (_ctx.showCatatan(slotProps.data.Id))
                          }, [
                            (_openBlock(), _createBlock("svg", _hoisted_25, [
                              _createVNode("g", _hoisted_26, [
                                _createVNode("path", {
                                  d: "M5 1a.5.5 0 0 1 .5.5V2h2v-.5a.5.5 0 0 1 1 0V2h2v-.5a.5.5 0 0 1 1 0V2A1.5 1.5 0 0 1 13 3.5v2.536a2.547 2.547 0 0 0-1 .406V3.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1.547v.002a1.59 1.59 0 0 0 .068.998H4.5A1.5 1.5 0 0 1 3 13.5v-10A1.5 1.5 0 0 1 4.5 2v-.5A.5.5 0 0 1 5 1zm5 7c.107 0 .206.034.288.091L9.378 9H6a.5.5 0 0 1 0-1h4zm-3.004 3.435A.5.5 0 0 0 6.5 11H6a.5.5 0 0 0 0 1h.5a.498.498 0 0 0 .157-.025c.097-.189.21-.37.339-.54zM6 5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6zm6.338 2.455a1.56 1.56 0 0 1 2.207 2.207l-4.289 4.288a2.777 2.777 0 0 1-1.29.731l-1.211.303a.61.61 0 0 1-.74-.74l.304-1.21c.122-.489.374-.935.73-1.29l4.289-4.289z",
                                  fill: (slotProps.data.Keterangan) ? '#ff9800' : '#607D8B'
                                }, null, 8, ["fill"])
                              ])
                            ])),
                            _createVNode("p", {
                              class: slotProps.data.Keterangan ? 'color-primary' : ''
                            }, "Catatan", 2)
                          ], 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            class: "p-button-link px-1",
                            onClick: ($event: any) => (_ctx.deleteItems(slotProps.data.Id, slotProps.index))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ])
                  }
                : undefined
            ]), 1024)
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_28, [
      _createVNode("div", _hoisted_29, [
        _createVNode(_component_Button, {
          class: "btn-primary text-black mr-3 px-10 py-1",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitData()))
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black px-10 py-1",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitBack()))
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "Catatan Barang",
      visible: _ctx.dialogCatatan,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogCatatan = $event)),
      dismissableMask: true,
      modal: true,
      onHide: _cache[12] || (_cache[12] = ($event: any) => (_ctx.hideDialog()))
    }, {
      default: _withCtx(() => [
        _createVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submitCatatan()), ["prevent"]))
        }, [
          _createVNode(_component_Textarea, {
            rows: "5",
            modelValue: _ctx.inputCatatan,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.inputCatatan = $event)),
            class: "input-primary",
            cols: "30"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_32, [
            _createVNode(_component_Button, {
              class: "btn-primary",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}